var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.demoEvent
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.updateDemoEvent.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.title,
                              expression: "rules.title"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Event Title",
                            placeholder: "Enter Event Title",
                            "data-vv-name": "title",
                            "cus-name": "title",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.demoEvent.title,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "title", $$v)
                            },
                            expression: "demoEvent.title"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.type.length
                      ? _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.type,
                                  expression: "rules.type"
                                }
                              ],
                              attrs: {
                                label: "Type",
                                "data-vv-name": "type",
                                "cus-name": "type",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.type,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.demoEvent.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.demoEvent, "type", $$v)
                                },
                                expression: "demoEvent.type"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("label", [_vm._v("Start Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            required: "",
                            "input-class": "form-control",
                            placeholder: "Choose a Date",
                            type: "datetime",
                            "min-datetime": _vm.today,
                            "input-format": "DD-MM-YYYY HH:mm",
                            "auto-continue": ""
                          },
                          model: {
                            value: _vm.startDate,
                            callback: function($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.description,
                              expression: "rules.description"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Event Description",
                            placeholder: "Enter Event Description",
                            "data-vv-name": "description",
                            "cus-name": "description",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.demoEvent.description,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "description", $$v)
                            },
                            expression: "demoEvent.description"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.longDescription,
                              expression: "rules.longDescription"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Long Description",
                            placeholder: "Enter Event Long Description",
                            "data-vv-name": "Long Description",
                            "cus-name": "Long Description",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.demoEvent.longDescription,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "longDescription", $$v)
                            },
                            expression: "demoEvent.longDescription"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Event Description Message",
                            placeholder: "Enter Message"
                          },
                          model: {
                            value: _vm.demoEvent.jwStreamTitle,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "jwStreamTitle", $$v)
                            },
                            expression: "demoEvent.jwStreamTitle"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "JW RTMP URL",
                            placeholder: "Enter JW RTMP URL"
                          },
                          model: {
                            value: _vm.demoEvent.jwRtmpUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "jwRtmpUrl", $$v)
                            },
                            expression: "demoEvent.jwRtmpUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Event Image Url",
                            placeholder: "Enter Image Url"
                          },
                          model: {
                            value: _vm.demoEvent.imgUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "imgUrl", $$v)
                            },
                            expression: "demoEvent.imgUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.chatrollEventUrl,
                              expression: "rules.chatrollEventUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Chat Roll Event Name",
                            placeholder: "Enter Chat Roll Event Name",
                            "data-vv-name": "chatroll_event_name",
                            "cus-name": "chatroll_event_name",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.demoEvent.chatrollEventUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "chatrollEventUrl", $$v)
                            },
                            expression: "demoEvent.chatrollEventUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.experts.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.expertId,
                                  expression: "rules.expertId"
                                }
                              ],
                              attrs: {
                                label: "Expert ID",
                                "data-vv-name": "expertId",
                                "cus-name": "expertId",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.experts,
                                selectedKey: "expertId"
                              },
                              model: {
                                value: _vm.demoEvent.expertId,
                                callback: function($$v) {
                                  _vm.$set(_vm.demoEvent, "expertId", $$v)
                                },
                                expression: "demoEvent.expertId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Promo Video Code",
                            placeholder: "Video Code"
                          },
                          model: {
                            value: _vm.demoEvent.videoCode,
                            callback: function($$v) {
                              _vm.$set(_vm.demoEvent, "videoCode", $$v)
                            },
                            expression: "demoEvent.videoCode"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("legend", [_vm._v("Corporate Community Demo Settings")]),
                  _c("hr"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.corporations.length
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("fg-select", {
                            attrs: {
                              label:
                                "Select Corporation for Corporate Community Page",
                              list: _vm.corporations,
                              selectedKey: "corporationId"
                            },
                            model: {
                              value: _vm.demoEvent.demoCorporationId,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.demoEvent,
                                  "demoCorporationId",
                                  $$v
                                )
                              },
                              expression: "demoEvent.demoCorporationId"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Update Event\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Configure Demo Event")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c475c61e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c475c61e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/EditDemoEvent.vue
// module id = 6n65
// module chunks = 0